import {register} from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';
import $ from 'jquery';
import _ from 'jquery-match-height';

register('testimonials', {
  onLoad() {
    this.init();
    $('.article__testimonial').matchHeight();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `#testimonials--${id}`;
    const swiper = new Swiper(target, {
      slidesPerView: 3,
      loop: true,
      spaceBetween: 20,
      centeredSlides: false,
      autoHeight: true,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 40,
          centeredSlides: true,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 32,
          centeredSlides: false,
        },
        1020: {
          slidesPerView: 3,
          spaceBetween: 32,
          centeredSlides: false,
        },
      },
    });
    swiper.on('slideChange', () => {
      console.log('slide changed');
      // console.log(target.replace('#', ''));
      const videoEmbed = document
        .getElementById(target.replace('#', ''))
        .getElementsByClassName('wistia_embed');
      Array.prototype.forEach.call(videoEmbed, (videoLoad) => {
        // const videoHandle = videoLoad.getAttribute('data-video-handle');
        // console.log(`Slider video: ${videoId}`);
        window._wq = window._wq || [];
        _wq.push({
          id: '_all',
          onReady(video) {
            console.log('Stop video');
            video.pause();
          },
        });
      });
    });
  },
});
